import { render, staticRenderFns } from "./AccountHistoryTable.vue?vue&type=template&id=f3436ff6"
import script from "./AccountHistoryTable.vue?vue&type=script&lang=js"
export * from "./AccountHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./AccountHistoryTable.vue?vue&type=style&index=0&id=f3436ff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports